export enum CityEnum {
  Leipzig = "leipzig",
  Halle = "halle",
}
